import en from "./en.json";
import jp from "./jp.json";

const translations = {
  en,
  jp,
};

export default translations;
